module.exports = __webpack_public_path__ + "static/media/5_armies.7130ff05.png";